module.exports = __webpack_public_path__ + "img/product-center-normaeapp.e5e3d58e.png";